import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { checkRole } from "@/api/data";
import { banIpLogin } from "@/api/role";
import serverList from "../../../components/serverList/serverOptions.vue";
export default {
  name: "banSomeIp",
  components: {
    serverList: serverList
  },
  data: function data() {
    return {
      hour: 60 * 60,
      day: 24 * 60 * 60,
      year: 365 * 24 * 60 * 60,
      form: {
        time: ""
      },
      //玩家ID输入的字符串,后面转数组
      playerIDString: ""
    };
  },
  watch: {
    playerIDString: {
      handler: function handler(newVal) {
        if (newVal.indexOf('\n') !== -1) {
          this.$message({
            type: "error",
            message: "请使用逗号分割"
          });
        }
        this.form.ip_list = newVal.split(",");
      }
    }
  },
  methods: {
    //多人封禁
    preserBtn: function preserBtn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var time, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 检查输入时间是否有效，是否有超出范围
              time = Math.round(_this.form.time);
              if (!(isNaN(time) || time < 0)) {
                _context.next = 4;
                break;
              }
              _this.$message({
                type: "error",
                message: "封禁时间必须为正数"
              });
              return _context.abrupt("return");
            case 4:
              if (!(time > 50 * _this.year)) {
                _context.next = 7;
                break;
              }
              _this.$message({
                type: "error",
                message: "封禁时间不能超过50年"
              });
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return banIpLogin(_this.form);
            case 9:
              res = _context.sent;
              if (res.code == 0) {
                _this.centerDialogVisible = false;
                _this.$message({
                  type: "success",
                  message: "封禁成功"
                });
                _this.backPerson();
              } else {
                _this.$message({
                  type: "error",
                  message: "封禁失败"
                });
                // this.backPerson();
              }
              // } else {
              //     this.$message({
              //         type: "error",
              //         message: "封禁中的ID不存在",
              //     });
              //     this.playerIDString = "";
              // }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    backPerson: function backPerson() {
      var data = {
        isBack: false
      };
      this.$emit("backPerson", data);
    },
    setTime: function setTime(seconds) {
      this.form.time = String(seconds);
    }
  }
};